/**
 * controls default locale for app and web
 */
const defaultLocale = 'en-GB';
export default defaultLocale;